
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp/[uuid]",
      function () {
        return require("private-next-pages/lp/[uuid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lp/[uuid]"])
      });
    }
  